import React, { useState, useRef } from 'react';
import { useAuth } from '../../../../auth';
import { SiteLink, useRouter } from '../../..';
import { useGet } from '../../..';
import env from '../../../../env';
import { getAuthErrorMessage } from '../../../../utils/authErrorMessages';
// import { useUsers } from '../../users/users';

export function LoginAdmin(props) {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [pending, setPending] = React.useState(false);
  const [agreed, setAgreed] = React.useState(false);
  const auth = useAuth();
  // const users = useUsers();

  const router = useRouter();
  const [user, setUser] = useState(null);

  // ...existing state
  const isMounted = useRef(true);

  React.useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  // const get = useGet();
  //     React.useEffect(() => {
  //       if (auth.user) {
  //         get.send(env.apiBase + '/api/users/getusers')
  //           .then((response) => {
  //             setUser(response.data);
  //           })
  //           .catch((error) => {
  //             setError(error);
  //           })
  //       }
  //       // eslint-disable-next-line
  //     }, []);

  // const get = useGet();

  // React.useEffect(() => {
  //   if (auth.user) {
  //     get.send(`${env.apiBase}/api/profile/getroles/${auth.user.uid}`)
  //       .then(response => {
  //         setUser(response.data);
  //       })
  //       .catch(error => {
  //         setError(error);
  //       })
  //   }
  //   // eslint-disable-next-line
  // }, []);
  
  function submit(e) {
    setPending(true);
    //console.log('loggin', username, password)
    e.preventDefault();
    e.stopPropagation();

    auth.signinV2(username, password).then(session => {
      setPending(false);
      setError('');
      router.push('/dashboard');
    }).catch(error => {
      setPending(false);
      setError(getAuthErrorMessage(error));
    });
  }
  return (
    <div className="sign-in auth-panel"  style={{maxWidth: '600px', margin: 'auto'}}>
      <h1>Admin Log In</h1>
      <div className="loading-panel-holder" >
        <div className="panel-content">
          <form method="POST" noValidate="" onSubmit={submit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" className="form-control" name="email" required autoFocus
                onChange={event => {
                  setUsername(event.target.value);
                }} />
              <div className="invalid-feedback">
                Email is invalid
          </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" className="form-control" name="password" required
                onChange={event => {
                  setPassword(event.target.value);
                }} />
              <div className="invalid-feedback">
                Password is required
          </div>
            </div>
            <div className="form-group">
              <div className='form-check'>
                <input type="checkbox" name="privacy" id="privacy" className="form-check-input" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} required />
                <label htmlFor="remember" className="custom-control-label">
                  I agree to the <SiteLink to="/members-privacy">Privacy and Confidentiality Policy</SiteLink>
                </label>
              </div>
            </div>

            <div className="form-group m-0">
              <button type="submit" disabled={pending} className="btn btn-primary btn-block">
                {pending && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                <span className="">Log In</span>
              </button>
            </div>

            {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}

          </form>
        </div>
      </div>
    </div>)
}